var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetchWithTimeout } from "@/utils";
export const sendClassifiedAnalytics = (analyticsUrl, data) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield fetchWithTimeout(analyticsUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        if (!response.ok) {
            console.log("Failed to send classified analytics view. Response: ", response);
        }
    }
    catch (error) {
        console.log("Failed to send classified analytics view");
    }
    return {};
});
